import GennevApiService from "../services/gennev-api.service";
import { addRefreshAuthToAuthProvider } from "react-admin";

const clearSession = () => {
  localStorage.removeItem("username");
  localStorage.removeItem("token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("expiration");
  GennevApiService.removeToken();
};

const getTokens = () => {
  return {
    token: localStorage.getItem("token"),
    refresh_token: localStorage.getItem("refresh_token"),
    expiration: localStorage.getItem("expiration"),
  };
};

const setTokens = (response) => {
  localStorage.setItem("username", response.user.nickname);
  localStorage.setItem("token", response.token);
  localStorage.setItem("refresh_token", response.refresh_token);
  localStorage.setItem("expiration", response.expiration);
  GennevApiService.setToken(response.token);
};

export const refreshAuth = async () => {
  const { refresh_token, expiration } = getTokens();

  if (!refresh_token) {
    return null;
  }
  const expirationNum = Number(expiration);
  const nowEpoch = Date.now() / 1000;
  if (expirationNum < nowEpoch) {
    // This function will fetch the new tokens from the authentication service and update them in localStorage
    const response = await GennevApiService.refreshToken(refresh_token);
    setTokens(response);
  }
  return Promise.resolve();
};

const myAuthProvider = {
  // called when the user attempts to log in
  login: async ({ username, password }) => {
    try {
      const response = await GennevApiService.login(username, password);
      setTokens(response);
    } catch (e) {
      return Promise.reject("Username or password are invalid");
    }
    return Promise.resolve();
  },
  // called when the user clicks on the logout button
  logout: () => {
    clearSession();
    return Promise.resolve();
  },
  // called when the API returns an error
  checkError: ({ status }) => {
    if (status === 401 || status === 403) {
      clearSession();
      return Promise.reject();
    }
    return Promise.resolve();
  },
  // called when the user navigates to a new location, to check for authentication
  checkAuth: () => {
    return localStorage.getItem("token") ? Promise.resolve() : Promise.reject();
  },
  // called when the user navigates to a new location, to check for permissions / roles
  getPermissions: async () => {
    let hasPermission = false;

    try {
      const user = await GennevApiService.me();
      if (Array.isArray(user.user.roles)) {
        hasPermission = user.user.roles.find((role) => role === "ADMIN");
      }
    } catch (e) {
      return Promise.reject("Restricted section");
    }

    if (!hasPermission) {
      return Promise.reject("Restricted section");
    }

    return Promise.resolve();
  },
};

export default addRefreshAuthToAuthProvider(myAuthProvider, refreshAuth);
